// @flow

import _ from 'lodash';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { GlobalStylesProvider } from '@zapier/design-system';

import { Account } from '@zapier/shared-entities';
import TeamAccountActions from 'app/team-account/TeamAccountActions';
import App from 'app/team-account/components/App';

import { type Dispatch } from 'app/common/types';

type Props = {
  accountId: number,
  onStartTrialImmediately: number => void,
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onStartTrialImmediately(id) {
      dispatch(TeamAccountActions.startTrialImmediately(id));
    },
  };
};

const mapStateToProps = state => {
  return {
    accountId: Account.selectors.all.currentAccountId(state),
  };
};

const AppContainer = ({ accountId, onStartTrialImmediately }: Props) => {
  // Start a trial right away - now the action for all users
  useEffect(() => {
    if (accountId) {
      onStartTrialImmediately(accountId);
    }
  }, [onStartTrialImmediately, accountId]);

  return (
    <GlobalStylesProvider isRebrand={true}>
      <App />
    </GlobalStylesProvider>
  );
};

export default _.flowRight(connect(mapStateToProps, mapDispatchToProps))(
  AppContainer
);
